// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xF-z","smallCardRow":"yF-z","largeCardRow":"zF-z","productSearchRow":"AF-z","curatedRow":"BF-z"};